import { AdminListView } from "./AdminListView";
import { facilityAdapter } from "./facilityAdapter";

export function FacilityAdminPage() {
  return <AdminListView adapter={facilityAdapter} />;
}
